import {useContentStore, useProductStore, usePromotionStore} from '../../store/hooks/useStore'
import {useEffect, useState} from 'react'
import {flowResult, toJS} from 'mobx'
import {Nullable} from '../../types/utils'
import {PromotionResponse} from '../../store/PromotionStore'
import {useSearchParams} from '../../hooks/use-search-params'

const PROMO_QUERY_NAME = 'promo'

export const useMealDeals = () => {
  const searchParams = useSearchParams()
  const {fetchItemByKey} = useContentStore()
  const {fetchProducts} = useProductStore()
  const {fetchPromotionsByIds, promotions} = usePromotionStore()

  const [mealDeals, setMealDeals] = useState<Nullable<PromotionResponse>>(null)
  const [dealStatus, setDealStatus] = useState<'initial' | 'loading' | 'done'>('initial')

  useEffect(() => {
    if (dealStatus === 'loading' || mealDeals != null) return
    async function fetchMealDeal() {
      const promoName = searchParams.get(PROMO_QUERY_NAME) || ''
      if (promoName) {
        setDealStatus('loading')
        await flowResult(fetchPromotionsByIds([promoName]))
        const res = toJS(promotions?.[promoName])
        if (res) {
          if (res?.productIds?.length) {
            await flowResult(fetchProducts(res.productIds, false))
          }
          setMealDeals(res as unknown as PromotionResponse)
          setDealStatus('done')
        }
        else {
          setDealStatus('done')
        }
      }
      else {
        setDealStatus('done')
      }
    }
    fetchMealDeal()
  }, [
      dealStatus,
      mealDeals,
      searchParams,
      fetchPromotionsByIds,
      fetchProducts,
      fetchItemByKey,
      promotions,
    ])

  return {
    mealDeals,
    dealStatus
  }
}